import React from 'react';
import LadderEmoji from 'react/elements/LadderEmoji';
import { __ } from 'i18n/index';

export const QUICK_REACTION_EMOJI = '+1';

// Shown over a message on hover: a quick 👍 reaction and the message menu
// (the same menu as right-clicking the message).
export default function MessageHoverToolbar({ onQuickReact, onOpenMenu }) {
	const stopThen = (handler) => (event) => {
		event.stopPropagation();
		handler(event);
	};
	return (
		<span className='chat-message-toolbar'>
			<button
				type='button'
				className='chat-message-toolbar__button'
				onClick={stopThen(onQuickReact)}
				aria-label={__('React with thumbs up')}
				title={__('React with thumbs up')}
			>
				<LadderEmoji emoji={QUICK_REACTION_EMOJI} size={16} tooltip={false} />
			</button>
			<button
				type='button'
				className='chat-message-toolbar__button'
				onClick={stopThen(onOpenMenu)}
				aria-label={__('More')}
				title={__('More')}
			>
				<i className='fa fa-ellipsis-h' aria-hidden='true' />
			</button>
		</span>
	);
}
